import React from 'react'
import { Link } from 'react-router-dom';
import { AdminArea } from '../types';
import AdminAreaSection from './adminAreaSection';

interface AdminAreaListingProps {
    adminAreas: AdminArea[]
}

const AdminAreaListing = (props: AdminAreaListingProps) => {
    // A single state's page lists its areas in columns; all states flow as cards
    const single = props.adminAreas.length === 1;
    if (props.adminAreas.length === 0) {
        return (
            <div className="cw-card">
                <p className="cw-card__message" style={{ marginTop: 0 }}>
                    No climbing areas are listed here yet. <Link to="/forecast-by-state">See all states</Link>.
                </p>
            </div>
        );
    }
    return (
        <div className={single ? "state-areas-single" : "state-areas-grid"}>
            {props.adminAreas.map((adminArea) => (
                <AdminAreaSection
                    key={adminArea.name}
                    adminArea={adminArea}
                    linkHeading={!single}
                />
            ))}
        </div>
    )
};

export default AdminAreaListing;
